import { Quote, Star } from "lucide-react";

const ITEMS = [
  { name: "Juliana Martins", role: "Arquiteta – São Paulo/SP", text: "“O PROSPERA+ transformou a forma como lido com o dinheiro no dia a dia. Eu vivia no sufoco com despesas acumuladas e hoje consigo ter controle total, poupar e investir no meu futuro.”" },
  { name: "Marcelo Ribeiro", role: "Empresário – Campinas/SP", text: "“Prático, intuitivo e direto ao ponto. Em menos de dois meses de uso, consegui organizar o fluxo de caixa do meu negócio e equilibrar as contas pessoais com muita tranquilidade.”" },
  { name: "Rodrigo Almeida", role: "Consultoria Almeida & Silva – Ribeirão Preto/SP", text: "“Sempre tive dificuldade em separar as despesas da empresa das contas pessoais, mas o PROSPERA+ tornou tudo simples e automático. Finalmente ganhei previsibilidade financeira e paz de espírito.”" },
];

export const Testimonials = () => (
  <section className="relative z-10 mx-auto max-w-7xl px-5 py-16" data-testid="testimonials-section">
    <h2 className="text-2xl font-semibold sm:text-3xl">Quem usa, recomenda</h2>
    <p className="mb-10 mt-2 text-slate-400">Histórias de quem organizou as finanças com o PROSPERA+.</p>
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {ITEMS.map((t, i) => (
        <figure key={i} className="card-p flex flex-col p-6 fade-up hover:-translate-y-1" style={{ animationDelay: `${i * 80}ms` }} data-testid={`testimonial-${i}`}>
          <Quote className="h-7 w-7 text-[#D4AF37]" />
          <div className="mt-3 flex gap-0.5">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />)}</div>
          <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-300">{t.text}</blockquote>
          <figcaption className="mt-6 flex items-center gap-3 border-t border-[#1E3A6E]/60 pt-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#D4AF37]/15 font-semibold text-[#F5D77F]">{t.name.replace(/[[\]]/g, "").charAt(0)}</span>
            <span><span className="block text-sm font-semibold text-white">{t.name}</span><span className="block text-xs text-slate-500">{t.role}</span></span>
          </figcaption>
        </figure>
      ))}
    </div>
  </section>
);
